import { render, staticRenderFns } from "./MpInstallments.vue?vue&type=template&id=20921e06&scoped=true&"
import script from "./MpInstallments.vue?vue&type=script&lang=js&"
export * from "./MpInstallments.vue?vue&type=script&lang=js&"
import style0 from "./MpInstallments.vue?vue&type=style&index=0&id=20921e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20921e06",
  null
  
)

export default component.exports